import { Controller } from "@hotwired/stimulus"

// Controller for the new-page layout picker modal.
//
// Distinct from the existing `layout-picker` controller, which handles row
// column-layout selection on the page edit screen. Both controllers can be
// active on the same admin/pages screen, so they must remain separate.
export default class extends Controller {
  static targets = ["modal", "card", "form", "layoutKeyInput"]
  static values = { defaultKey: String }

  connect() {
    if (this.defaultKeyValue) {
      this.layoutKeyInputTarget.value = this.defaultKeyValue
      this._highlight(this.defaultKeyValue)
    }
    this._focusInitial()
  }

  select(event) {
    const key = event.currentTarget.dataset.layoutKey
    this.layoutKeyInputTarget.value = key
    this._highlight(key)
    this.formTarget.classList.remove("hidden")
  }

  // The picker IS the new-page screen — the modal sits over an empty
  // viewport, so simply removing it would leave the admin staring at a
  // blank page. Cancel returns to the pages index, derived from the
  // current path by stripping the trailing `/new` (works for both `/a`
  // and `/admin` mount prefixes without hardcoding either).
  close() {
    const target = window.location.pathname.replace(/\/new\/?$/, "") || "/"
    if (window.Turbo) {
      window.Turbo.visit(target)
    } else {
      window.location.href = target
    }
  }

  closeOnOverlay(event) {
    if (event.target === event.currentTarget) this.close()
  }

  _highlight(key) {
    this.cardTargets.forEach((c) => {
      const isSelected = c.dataset.layoutKey === key
      c.classList.toggle("sh-layout-card-selected", isSelected)
      c.classList.toggle("ring-2", isSelected)
      c.classList.toggle("ring-emerald-600", isSelected)
      c.classList.toggle("border-emerald-600", isSelected)
    })
  }

  _focusInitial() {
    const target = this.hasCardTarget
      ? (this.cardTargets.find((c) => c.dataset.layoutKey === this.defaultKeyValue) || this.cardTargets[0])
      : null
    if (target) requestAnimationFrame(() => target.focus())
  }
}
